const service = [
  {
    image: "images/services/data_mining-removebg.png",
    backgroundColor: { backgroundColor: "#EAECEF" },
    title: "Data Mining",
    description:
      "We transform your raw data into structured, valuable information.",
    text: "Our data mining solutions are designed to build reliable, scalable infrastructures that support your data-driven initiatives, ensuring you get the insights you need when you need them",
  },
  {
    image: "images/services/AI-removebg.png",
    backgroundColor: { backgroundColor: "#EDEDED" },
    title: "Artificial Intelligence",
    description:
      "Our AI services are tailored to meet the unique needs of your business.",
    text: "From automating processes to predictive analytics, we build machine learning models that provide actionable insights and deliver measurable impact.​",
  },
  {
    image: "images/services/advanced_analysis-removebg.png",
    backgroundColor: { backgroundColor: "#CDD4DA" },
    title: "Advanced Analytics",
    description: "We help organizations make sense of complex datasets.",
    text: "Whether it's uncovering patterns in customer behavior, identifying operational inefficiencies, our team provides real-time data analytics and dashboards that turn information into strategic actions.",
  },
  {
    image: "images/services/app_dev-removebg.png",
    backgroundColor: { backgroundColor: "#D9D9D9" },
    title: "Application Development",
    description:
      "We design and develop custom business applications tailored to your operational needs.",
    text: "Whether you require specialized internal tools or client-facing platforms, our applications are built to integrate seamlessly with your data infrastructure, improving efficiency and user experiences.",
  },
];

export default service;
